import { useState } from 'react';

import { Suspense } from '@sorare/core/src/atoms/Suspense';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { lazy } from '@sorare/core/src/lib/retry';

const PendingPackReveal = lazy(
  async () =>
    import('@sorare/marketplace/src/components/commonCard/PendingPackReveal/index.tsx'),
  'PendingPackReveal'
);

export const ClaimablePacksReveal = () => {
  const { currentUser, loading } = useCurrentUserContext();

  const [packIds, setPackIds] = useState<string[]>();

  // Seed once from the packs present when the user first loads, then freeze:
  // packs that become claimable later in the session (e.g. a just-claimed daily
  // pack) are revealed by their own claim flow, so this must not reveal them a
  // second time.
  if (packIds === undefined && !loading) {
    setPackIds(currentUser?.claimablePacks.map(pack => pack.id) ?? []);
  }

  const currentPackId = packIds?.at(0);
  if (!currentPackId) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <PendingPackReveal
        key={currentPackId}
        packId={currentPackId}
        onDone={() => setPackIds(previous => previous?.slice(1) ?? [])}
      />
    </Suspense>
  );
};
